/**
 * Created by houyulei on 2016/5/19.
 */
var $ = require('jquery');
import {SET_VIEW_SCROLL_TOP, RESET_SCROLL_TOP} from './action';

function scrollTop(state = {}, action) {
    switch (action.type) {
        case SET_VIEW_SCROLL_TOP:
            return $.extend({}, state, {
                [action.path]: action.top
            });
        case RESET_SCROLL_TOP:
            return {};
        default:
            return state;

    }
}

export default scrollTop;


// WEBPACK FOOTER //
// ./components/redux/scrolltop/reducer.js